// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React, {useState, useCallback} from 'react';
import cn from 'classnames';
import {useStore} from '@nanostores/react';
import {$user} from '@pub/store/user.js';
import {Tabs} from '@pub/comp/tabs';
import {Text} from '@pub/comp/text';
import {Text_input} from '@pub/comp/text_input';
import {Button} from '@pub/comp/button';
import {mimic_by_query} from '@pub/utils/user.js';
import {Selected_user} from '@pub/comp/selected_user';
import {Editing} from './tabs/editing.js';
import {Referral} from './tabs/referral.js';
import {Suspension} from './tabs/suspension.js';
import * as cns from './root_zone.module.less';

const TABS = [
    {label: 'Edit', value: 'editing', ico: 'edit', comp: Editing},
    {label: 'Connections', value: 'referral', ico: 'referral', comp: Referral},
    {label: 'Suspension', value: 'suspension', ico: 'pending',
        comp: Suspension},
];
const comps = TABS.reduce((acc, item)=>{
    acc[item.value] = item.comp;
    return acc;
}, {});

function User_view({value}){
    return <div>
      <Text.m>Selected user</Text.m>
      <Selected_user user={value}/>
    </div>;
}

function User_selector({on_apply}){
    const [query, set_query] = useState('');
    const handle_apply = useCallback(()=>on_apply?.(query), [query]);
    return <div>
      <Text.m>Select a user</Text.m>
      <Text.xs secondary>
        Search by email or User ID or Device UUID
      </Text.xs>
      <div className={cns.row}>
        <Text_input placeholder="Query"
          value={query} on_change={set_query} on_enter={handle_apply}
          size="s"/>
        <Button on_click={handle_apply}
          disabled={!query} size="s" color_scheme="primary" filled>
          Apply
        </Button>
      </div>
    </div>;
}

const get_selected = user=>{
    if (user.original_user)
        return user;
    return null;
};

function User_picker({user_rec}){
    const selected_user = get_selected(user_rec);
    return selected_user
        ? <User_view value={selected_user}/>
        : <User_selector on_apply={mimic_by_query}/>;
}

export function Root_zone({className}){
    const [tab, set_tab] = useState(TABS[0].value);
    const user_rec = useStore($user);
    const selected_user = get_selected(user_rec);
    const Content_comp = comps[tab];
    return <div className={cn(cns.root, className)}>
      <User_picker user_rec={user_rec}/>
      {!!selected_user&&<>
        <Text.l h2 className={cns.manage_title}>Management</Text.l>
        <Tabs active_value={tab} on_activate={set_tab} size="m" items={TABS}/>
        <Content_comp user={selected_user}/>
      </>}
    </div>;
}
